import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Paper, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const stylesTextAmount = {
  fontFamily: "Patua One",
  fontWeight: 400,
  lineHeight: "1",
};

const stylesTextSubtotal = {
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "1",
  color: "#191D23",
};

const stylesTextButton = {
  fontFamily: "Patua One",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "19.5px",
};

const ButtonBlue = styled(Button)(() => ({
  background: "#2287B8",
  textTransform: "initial",
  borderRadius: "10px",
  "&:hover": {
    background: "#1C6C94FF",
  },
}));

const ButtonGray = styled(Button)(() => ({
  border: "1px solid #D0D5DD",
  color: "#979797",
  textTransform: "initial",
  borderRadius: "10px",
}));

const RowSubtotal = ({ amount }) => {
  return (
    <>
      <Grid item xs={8} sx={{ borderTop: "1px solid #46AA71", pt: 1, mt: 2, ...stylesTextSubtotal }}>
        Subtotal
      </Grid>
      <Grid
        item
        xs={4}
        sx={{ borderTop: "1px solid #46AA71", pt: 1, mt: 2, fontSize: "16px", color: "#64748B", textAlign: "right", ...stylesTextAmount }}
      >
        {amount}
      </Grid>
    </>
  );
};

const RowIVA = ({ amount }) => {
  return (
    <>
      <Grid item xs={8} sx={{ borderBottom: "1px solid #46AA71", pt: 1, pb: 2, ...stylesTextSubtotal }}>
        IVA @ 16.00%
      </Grid>
      <Grid
        item
        xs={4}
        sx={{ borderBottom: "1px solid #46AA71", pt: 1, pb: 2, fontSize: "16px", color: "#64748B", textAlign: "right", ...stylesTextAmount }}
      >
        {amount}
      </Grid>
    </>
  );
};

const RowTotal = ({ amount }) => {
  return (
    <>
      <Grid item xs={4} sx={{ mt: 2, mb: 4, fontSize: "18px", color: "#191D23", ...stylesTextAmount }}>
        Total
      </Grid>
      <Grid item xs={8} sx={{ mt: 2, mb: 4, fontSize: "18px", color: "#191D23", textAlign: "right", ...stylesTextAmount }}>
        {amount}
      </Grid>
    </>
  );
};

const DrawerFooter = ({ itemsAddCart = [], formatAmount }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [subtotal, setSubtotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total, setTotal] = useState(0);
  const urlV4 = process.env.REACT_APP_V4_BASE_URL
  
  /**
   * @see src/components/Resumen/Resumen.js
   */
  useEffect(() => {
    let subtotalTemp = 0;
    let ivaTemp = 0;

    itemsAddCart.forEach((resumen) => {
      // Verificar si resumen.price.second_price existe y es una cadena
      const secondPrice = resumen.price && typeof resumen.price.second_price === "string" ? resumen.price.second_price.replace(/,/g, "") : 0; // Valor predeterminado en caso de que no sea una cadena
      subtotalTemp += parseFloat(secondPrice);

      if (resumen.product.privacy_protection) {
        subtotalTemp += parseFloat(resumen.price.privacy_cost);
      }
    });

    if (subtotalTemp > 0) {
      ivaTemp = subtotalTemp * 0.16;
    }

    setSubtotal(subtotalTemp);
    setIva(ivaTemp);
    setTotal(subtotalTemp + ivaTemp);
  }, [itemsAddCart]);

  const clickCheckout = () => {
    navigate("/checkout");
  };

  return (
    <Box sx={{ pt: 2, px: 3, pb: 3 }}>
      <Grid container rowSpacing={2}>
        <RowSubtotal amount={formatAmount(subtotal)} />
        <RowIVA amount={formatAmount(iva)} />
        <RowTotal amount={formatAmount(total)} />
      </Grid>

      <ButtonBlue variant="contained" sx={{ mb: "1rem", ...stylesTextButton }} onClick={clickCheckout} size="large" fullWidth>
        {t("header.drawer.btn.checkout")}
      </ButtonBlue>
      <ButtonGray variant="outlined" sx={stylesTextButton} color="inherit" href={urlV4} size="large" fullWidth>
        {t("header.btn.back")}
      </ButtonGray>
    </Box>
  );
};

export default DrawerFooter;
